/*
 * This component is transforming. Currently there are many versions of shadow/frame component.
 * Benji has a vision on streamlining the frame/shadow and it's effects to a single style.
 * Below, you will see new styling for the Video variant of this component
 */
import React from 'react';
import { AnalyticsLocationProvider } from 'latitude-analytics';
import ReactPlayer from 'react-player/lazy';
import styled, { css } from 'styled-components';
import ReactHTMLParser from 'react-html-parser';
import { Heading3 } from '@latitude/heading';
import Text from '@latitude/text/Text';
import { BREAKPOINT, COLOR } from '@latitude/core/utils/constants';
import Section from '@latitude/section';
import playbtn from './img/play_button.svg';
import videoPoster from './img/video_poster_frame@2x.png';
/** Center the video/images if no content is provide */

var PromoContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "Promo__PromoContainer",
  componentId: "sc-dd3i45-0"
})(["display:flex;flex-direction:column;padding:0 16px;@media (min-width:", "){flex-direction:row;padding:0;", "}"], BREAKPOINT.LG, function (_ref) {
  var noContent = _ref.noContent;
  return noContent && css(["max-width:640px;justify-content:center;margin:auto;"]);
});
var PromoFrameContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "Promo__PromoFrameContainer",
  componentId: "sc-dd3i45-1"
})(["", ";position:relative;width:242px;height:215px;margin:0 auto 45px auto;", ";@media (min-width:", "){width:390px;height:346px;transform:none;margin:", ";order:", ";}svg{width:100%;height:100%;display:block;margin:0;@media (min-width:", "){width:100%;height:100%;}}img{width:242px;height:215px;display:block;margin:0;@media (min-width:", "){width:390px;height:346px;}}svg,img{position:relative;z-index:1;}&:after{display:block;width:100%;height:100%;content:'';position:absolute;top:45px;", ";border:solid 30px ", ";}"], function (_ref2) {
  var bgColor = _ref2.bgColor;
  return bgColor && css(["background-color:", ";"], bgColor);
}, function (_ref3) {
  var alignment = _ref3.alignment;
  return alignment === 'left' ? css(["transform:translateX(23px);"]) : css(["transform:translateX(-23px);"]);
}, BREAKPOINT.LG, function (_ref4) {
  var alignment = _ref4.alignment;
  return alignment === 'left' ? '0 0 45px 45px' : '0 45px 45px 0';
}, function (_ref5) {
  var alignment = _ref5.alignment;
  return alignment === 'left' ? 1 : 2;
}, BREAKPOINT.LG, BREAKPOINT.LG, function (_ref6) {
  var alignment = _ref6.alignment;
  return alignment === 'left' ? css(["left:-45px;"]) : css(["right:-45px;"]);
}, function (_ref7) {
  var borderColor = _ref7.borderColor;
  return borderColor;
});
var PromoButtons = /*#__PURE__*/styled.div.withConfig({
  displayName: "Promo__PromoButtons",
  componentId: "sc-dd3i45-2"
})(["margin:16px auto 0;.button{max-width:156px;margin-right:16px;", ";}> div{display:flex;}@media (min-width:", "){", ";}"], function (_ref8) {
  var alignment = _ref8.alignment;
  return alignment === 'right' && css(["margin-left:auto;"]);
}, BREAKPOINT.LG, function (_ref9) {
  var alignment = _ref9.alignment;
  return alignment === 'left' ? css(["margin-left:0;margin-right:0;"]) : css(["margin-left:auto;margin-right:0;text-align:right;"]);
});
var PromoContentContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "Promo__PromoContentContainer",
  componentId: "sc-dd3i45-3"
})(["padding:24px 0;text-align:center;", " h3{font-size:32px;line-height:1.13;margin-bottom:16px;color:", ";text-align:center;@media (min-width:", "){font-size:40px;line-height:1.2;text-align:", ";}}p{color:", ";text-align:center;@media (min-width:", "){max-width:320px;margin:0 auto;}@media (min-width:", "){margin:0;max-width:490px;text-align:", ";}}@media (min-width:", "){padding:32px;text-align:left;flex:0 1 auto;order:", ";}", ""], function (_ref10) {
  var verticalAlign = _ref10.verticalAlign;
  return verticalAlign && css(["display:flex;flex-direction:column;justify-content:center;"]);
}, COLOR.BLACK, BREAKPOINT.LG, function (_ref11) {
  var alignment = _ref11.alignment;
  return alignment === 'left' ? 'left' : 'right';
}, COLOR.GREY75, BREAKPOINT.SM, BREAKPOINT.LG, function (_ref12) {
  var alignment = _ref12.alignment;
  return alignment === 'left' ? 'left' : 'right';
}, BREAKPOINT.LG, function (_ref13) {
  var alignment = _ref13.alignment;
  return alignment === 'left' ? 2 : 1;
}, function (_ref14) {
  var frameVideoSrc = _ref14.frameVideoSrc;
  return frameVideoSrc && css(["display:flex;flex-direction:column;justify-content:flex-start;@media (min-width:", "){padding:0 32px;}"], BREAKPOINT.LG);
});
/*
 * VIDEO PROMO styles - These are different to cater to new design needs.
 * TODO: Style other variants of the Promo component to match this styling.
 */

var VideoPromoFrameContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "Promo__VideoPromoFrameContainer",
  componentId: "sc-dd3i45-4"
})(["", ";position:relative;width:300px;height:auto;max-width:100%;margin:0 auto 45px auto;", ";@media (min-width:", "){width:571px;height:320px;transform:none;flex:2 0 auto;margin:", ";order:", ";}&:before{display:block;width:100%;height:100%;content:'';position:absolute;top:30px;", ";border:solid 20px ", ";z-index:-1;@media (min-width:", "){top:60px;", ";border:solid 40px ", ";z-index:auto;}}"], function (_ref15) {
  var bgColor = _ref15.bgColor;
  return bgColor && css(["background-color:", ";"], bgColor);
}, function (_ref16) {
  var alignment = _ref16.alignment;
  return alignment === 'left' ? css(["transform:translateX(15px);"]) : css(["transform:translateX(-15px);"]);
}, BREAKPOINT.LG, function (_ref17) {
  var alignment = _ref17.alignment;
  return alignment === 'left' ? '0 0 45px 45px' : '0 45px 45px 0';
}, function (_ref18) {
  var alignment = _ref18.alignment;
  return alignment === 'left' ? 1 : 2;
}, function (_ref19) {
  var alignment = _ref19.alignment;
  return alignment === 'left' ? css(["left:-30px;"]) : css(["right:-30px;"]);
}, function (_ref20) {
  var borderColor = _ref20.borderColor;
  return borderColor;
}, BREAKPOINT.LG, function (_ref21) {
  var alignment = _ref21.alignment;
  return alignment === 'left' ? css(["left:-60px;"]) : css(["right:-60px;"]);
}, function (_ref22) {
  var borderColor = _ref22.borderColor;
  return borderColor;
});
var PlayerWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "Promo__PlayerWrapper",
  componentId: "sc-dd3i45-5"
})(["position:relative;padding-top:56.25%;.react-player{position:absolute;top:0;left:0;img{width:64px;height:64px;@media (min-width:", "){width:96px;height:96px;}}}"], BREAKPOINT.LG);

var Promo = function Promo(_ref23) {
  var frameImage = _ref23.frameImage,
      description = _ref23.description,
      title = _ref23.title,
      frameAlignment = _ref23.frameAlignment,
      frameBorderColor = _ref23.frameBorderColor,
      frameBackgroundColor = _ref23.frameBackgroundColor,
      verticalAlignContent = _ref23.verticalAlignContent,
      ctaButtons = _ref23.ctaButtons,
      frameVideoSrc = _ref23.frameVideoSrc,
      frameVideoImage = _ref23.frameVideoImage,
      noContent = _ref23.noContent;
  /**
   * Return sanitised location value for Tealium tracking
   */

  var sanitiseLocation = function sanitiseLocation(value) {
    if (value === undefined) return null;
    return value.toString().replace(/(<([^>]+)>)/gi, '');
  };

  return /*#__PURE__*/React.createElement(AnalyticsLocationProvider, {
    location: sanitiseLocation(title)
  }, /*#__PURE__*/React.createElement(PromoContainer, {
    noContent: noContent
  }, frameImage && /*#__PURE__*/React.createElement(PromoFrameContainer, {
    alignment: frameAlignment,
    borderColor: frameBorderColor,
    bgColor: frameBackgroundColor,
    noContent: noContent
  }, frameImage), frameVideoSrc && /*#__PURE__*/React.createElement(VideoPromoFrameContainer, {
    alignment: frameAlignment,
    borderColor: frameBorderColor,
    bgColor: frameBackgroundColor
  }, /*#__PURE__*/React.createElement(PlayerWrapper, null, /*#__PURE__*/React.createElement(ReactPlayer, {
    url: frameVideoSrc,
    className: "react-player",
    width: "100%",
    height: "100%",
    controls: true,
    light: frameVideoImage || videoPoster,
    playIcon: /*#__PURE__*/React.createElement("img", {
      src: playbtn,
      alt: "Play video"
    })
  }))), !noContent ? /*#__PURE__*/React.createElement(PromoContentContainer, {
    verticalAlign: verticalAlignContent,
    alignment: frameAlignment,
    frameVideoSrc: frameVideoSrc
  }, title && /*#__PURE__*/React.createElement(Heading3, null, ReactHTMLParser(title)), description && (typeof description === 'string' ? /*#__PURE__*/React.createElement(Text, {
    fontSize: "18px"
  }, ReactHTMLParser(description)) : description), ctaButtons && /*#__PURE__*/React.createElement(PromoButtons, {
    alignment: frameAlignment
  }, ctaButtons)) : null));
};

export var PromoSection = /*#__PURE__*/styled(Section).withConfig({
  displayName: "Promo__PromoSection",
  componentId: "sc-dd3i45-6"
})(["&&{z-index:0;padding-top:40px;padding-bottom:40px;.section__content{max-width:950px;}@media (min-width:", "){padding-top:72px;padding-bottom:72px;}}"], BREAKPOINT.LG);
export default Promo;